<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Info', route: '/backoffice/info' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Info</h1>
</section>

<section class="pb-16 mb-8 px-container">        
    <div class="row w-full flex gap-4 lg:justify-end">
        <button class="p-3 lg:w-1/6 w-full btn-outln mb-8 text-center" type="button" routerLink="/backoffice/info/add">                
            <i class="bi bi-plus"></i>
            Aggiungi info
        </button>
    </div>
            
    <p-table #dt [loading]="loading" [value]="infos" responsiveLayout="stack" [breakpoint]="'960px'" styleClass="p-datatable-striped" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true" [globalFilterFields]="['titoli']" currentPageReportTemplate="{first} di {last} su {totalRecords} info" [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]" (onRowReorder)="onReorder($event)">            
        <ng-template pTemplate="caption">            
            <span class="block lg:w-1/4 w-full p-input-icon-left">
                <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca..." class="w-full indent-6" />
            </span>                                        
        </ng-template>
        <ng-template pTemplate="header">
            <tr>        
                <th class="w-1/12"></th>            
                <th pSortableColumn="titoli" class="w-10/12">Titolo/i <span class="inline-flex"><p-sortIcon field="titoli" /></span></th>
                <th class="w-2/12 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-info let-index="rowIndex">
            <tr [pReorderableRow]="index">
                <td class="text-center">
                    <i class="bi bi-list text-4xl hover:text-black" pReorderableRowHandle></i>
                </td>
                <td><span class="p-column-title">Titolo/i</span>{{info.titoli}}</td>                
                <td class="md:justify-center justify-between flex">
                    <span class="p-column-title">Azioni</span>

                    <div class="flex flex-row items-center justify-center">                                    
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" [routerLink]="'/backoffice/info/' + info.id"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteInfo>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteInfo()">Elimina</button>
                                        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium"  (click)="onAnnullaDeleteInfo()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>

                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDeleteInfo($event, info)" ></i>
                    </div>                    
                </td>                    
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4">Nessuna info trovata.</td>
            </tr>
        </ng-template>
    </p-table>
</section>